// extracted by mini-css-extract-plugin
export default {"root":"Donate_root__Er1v8","radioInputs":"Donate_radioInputs__pnqmU"};